<template>
  <div @click="handleFullPageClick">
    <div class="themebg">
      <div class="theme-tl"></div>
      <div class="theme-tr"></div>
      <div class="theme-bl"></div>
    </div>
    <div class="header">
      <div class="logo">
        <img v-if="showImgLogo && pcLogo" v-bind:src="pcLogo" alt="" @error="handleLogoError">
        <p v-else>{{ textLogo }}</p>
      </div>
      <top-tabs ref="topTabs"></top-tabs>
      <top-user ></top-user>
    </div>
    <left-menu></left-menu>
    <ie-warning></ie-warning>
    <div :style="{left: (showLeftMenu ? 272 : 64) + 'px'}" class="main">
      <keep-alive :include="cachedViews" >
        <router-view v-show="!iframeState" ></router-view>
      </keep-alive>
      <!--<common-iframe
        v-show="iframeState"
        :showBackButton="showBackButton"
        :showTopOperation="showTopOperation"
        :bindRouteUrl="iframeBindRouteUrl"
        iframeName="mainContent" >
      </common-iframe>-->
    </div>
  </div>
</template>
<script>
  import LeftMenu from '../components/left-menu/left-menu.vue'
  import TopTabs from '../components/top-tabs/top-tabs.vue'
  import TopUser from '../components/top-user/top-user.vue'
  import CommonIframe from '../components/iframe/iframe.vue'
  import IeWarning from '../components/ie-warning/ie-warning.vue'
  import util from '../libs/util'
  import ws from '../websocket'

  export default {
    components: {
      LeftMenu,
      TopTabs,
      TopUser,
      CommonIframe,
      IeWarning
    },
    data() {
      return {
        showBackButton: true,
        showTopOperation: true,
        iframeBindRouteUrl: false,
        showImgLogo: true
      }
    },
    computed: {
      cachedViews() {
        return this.$store.state.app.cachedViews
      },
      iframeState: function () {
        return this.$store.state.app.showIframe
      },
      showLeftMenu: function () {
        return this.$store.state.app.showLeftMenu
      },
      pcLogo: function() {
        const peWebSiteDetail = this.$store.state.app.peWebSiteDetail
        if (peWebSiteDetail && peWebSiteDetail.pcLogo) {
          return util.baseUrl + '/' + peWebSiteDetail.pcLogo
        }
        return ''
      },
      textLogo() {
        const peWebSiteDetail = this.$store.state.app.peWebSiteDetail
        return peWebSiteDetail.title || '管理平台'
      }
    },
    created() {
      document.title = this.$store.state.app.peWebSiteDetail.title || '管理平台'
    },
    mounted() {
      if (util.enableWebSocket) {
        // 初始化webSocket
        ws.init()
      }
    },
    methods: {
      handleFullPageClick() { // 全页面点击事件
        this.$refs.topTabs.closeTopTabDropMenu()
      },
      handleLogoError() {
        this.showImgLogo = false
      }
    }
  }
</script>
<style lang="scss">
  .header {
    .logo {
      p {
        line-height: 89px;
        text-align: center;
        font-size: 22px;
        font-weight: bold;
        color: #fff;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/manager/manager_index.vue